module.exports = __webpack_public_path__ + "img/img31.7da5d341.svg";